import React, { useEffect, useState } from "react";
import useStyles from "../../../../components/common/model/styles";
// import ResetFormAlert from "./ResetFormAlert";
import Popup from "../../../../components/common/model/Popup";
import closeIcon from "../../../../assets/closeModel.png";
import checkedIcon from "../../../../assets/check-mark.png";
import deleteIcon from "../../../../assets/trash.png";
import { DialogContent, DialogContentText, Grid } from "@mui/material";
import Notification from "../../../../components/common/notification/Notification";
import Validation from "../../../../utils/Validation";
import { useDispatch } from "react-redux";
import { setNotificationAction } from "../../../../store/reducers/mmymSlice";
import { formElementFields } from "./saleAllFields";
import {
  addMaterialAction,
  initialMaterialLocalState,
  setAddMaterialResponse,
  updateMaterialAction,
  updateMaterialResponse,
} from "../../../../store/reducers/materialSlice";
import ResetFormAlert from "../manageReffer/ResetFormAlert";
import FirstFormField from "./FirstFormField";
import {
  addSaleAction,
  initialSaleLocalState,
  setNewSaleLocal,
} from "../../../../store/reducers/saleSlice";
import { useSelector } from "react-redux";
import LiabilityTypes from "./LiabilityTypes";
import LeadTypes from "./LeadTypes";
import PropertyType from "./PropertyType";

interface saleDetail {
  [key: string]: any; // Allow dynamic string keys
  minimum_profit_level: any | null;
  minimum_profit_level_message: any | null;
  is_minimum_profit_required: any | null;
  quote_expiry_days: any | null;
}

interface ManageSaleProps {
  open: boolean; // Define the 'open' prop
  onHide: () => void; // Define the 'onHide' prop
  title: string; // Define the 'title' prop
  selectUser: any; // Adjust type as per your requirement
  isSmallScreen?: boolean; //
}

const ManageSale = (props: ManageSaleProps) => {
  const classes = useStyles();
  const { selectUser, onHide, open, title, isSmallScreen } = props;
  const [resetAlert, setResetAlert] = useState(false);
  const [alertModel, setAlertModel] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [isChanged, setIsChanged] = useState(false);
  const { sales, newSaleLocal } = useSelector((state: any) => state.sale);
  const [saleDetail, setSaleDetail] = useState<saleDetail>(
    sales?.id ? { ...initialSaleLocalState, ...sales } : { ...initialSaleLocalState, sales },
  );
  const [fieldsToRender, setFieldsToRender] = useState(formElementFields); // Default to basic fields
  useEffect(() => {
    // Dynamically update form fields based on screen size
    if (isSmallScreen) {
      setFieldsToRender(formElementFields);
    }
    // else {
    //   setFieldsToRender(allFormElementFields);
    // }
  }, [isSmallScreen]);

  const [alerModeShow, setAlertModelShow] = useState(false);
  const [isClickReset, setIsClickReset] = useState(false);

  const [
    error,
    checkValidator,
    resetValidator,
    resetAllValidator,
    isError,
    isErrorOptional,
  ]: any = Validation({
    minimum_profit_level: saleDetail?.minimum_profit_level,
    minimum_profit_level_message: saleDetail?.minimum_profit_level_message,
  });

  useEffect(()=>{
    if(sales?.id || sales?.insurance_extended_liability_types?.length > 0){
      setSaleDetail({
        ...initialSaleLocalState,
        ...sales,
      });
    }else{
      setSaleDetail({
        ...initialSaleLocalState,
        sales,
      });
    }
  },[sales])

  const dispatch = useDispatch();

  const [isActionCalled, setIsActionCalled] = useState(false);

  const hideHandler = () => {
    onHide();
    handleClear();
    dispatch(setNotificationAction({ message: [], severity: "error" }));
    dispatch(setAddMaterialResponse(false));
    dispatch(updateMaterialResponse(false));
    setSaleDetail(initialSaleLocalState);
  };

  const handleClear = () => {
    if (sales?.id || sales?.insurance_extended_liability_types?.length > 0) {
      setSaleDetail(sales);
    } else {
      setSaleDetail({
        ...initialSaleLocalState,
        sales,
      });
    }
    resetAllValidator(); // Reset all validation errors
    setIsClickReset(false);
    setAlertModelShow(false);
    // setIsEmailActionCalled(false);
    // setRoleModules([]);
  };

  const openClearPopup = () => {
    setAlertModelShow(true);
  };

  useEffect(() => {
    if (isClickReset) {
      handleClear();
      setAlertModelShow(false);
    }
  }, [isClickReset]);

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    checkValidator();
    setIsActionCalled(true);
  };

  useEffect(() => {
    if (isActionCalled) {
      console.log("saleDetail", saleDetail);
      if (
        !isError() &&
        !isErrorOptional() &&
        error !== null &&
        isActionCalled
      ) {
        console.log("saleDetail BEFORE conversion", saleDetail);
        // Convert value and percent to numbers before submission
        const processedSaleDetail = {
          ...saleDetail,
          insurance_extended_liability_types:
            saleDetail?.insurance_extended_liability_types?.map((item: any) => {
              const hasValue = item.value != null && item.value !== "";
              const hasPercent = item.percent != null && item.percent !== "";

              return {
                ...item,
                value: hasValue ? Number(item.value) : null,
                percent: hasPercent ? Number(item.percent) : null,
                type: item.type || 'percent', // Ensure type is included, default to null if missing
              };
            }) || [],
        };
        console.log(
          "processedSaleDetail AFTER conversion",
          processedSaleDetail,
        );
        if (saleDetail?.id) {
          dispatch(
            addSaleAction({ ...processedSaleDetail, id: saleDetail?.id }),
          );
        } else {
          dispatch(addSaleAction(processedSaleDetail));
        }
      }
      setIsActionCalled(false);
    }
  }, [isActionCalled]);

  const handleInputChange = (field: string, value: any) => {
    setSaleDetail((prevState) => ({
      ...prevState,
      [field]: value,
    }));

    dispatch(
      setNewSaleLocal({
        ...newSaleLocal,
        [field]: value,
      }),
    );

    resetValidator(field);
  };

  const onBlurAction = (e: any) => {
    checkValidator(e.target.id);
  };
  return (
    <>
      <Popup
        open={open}
        title={title}
        onHide={hideHandler}
        fullWidth={true}
        maxWidth={"lg"}
        aria-describedby="alert-dialog-slide-description"
        popupBg="#fff"
        header={
          <>
            <img
              onClick={(e: any) => handleSubmit(e)}
              src={checkedIcon}
              className={classes.checkicons}
              alt="save"
            />
            <img
              onClick={openClearPopup}
              src={deleteIcon}
              className={classes.deleteicons}
              alt="delete"
            />
            <img
              onClick={hideHandler}
              src={closeIcon}
              className={classes.closeicons}
              alt="close"
            />
          </>
        }
      >
        <DialogContent sx={{ padding: "16px 10px !important" }}>
          <DialogContentText>
            <>
              <Notification />
              <Grid
                container
                spacing={2}
                sx={{
                  padding: "10px",
                  mt: 1,
                  background: "#E5F4F1",
                  borderRadius: "5px",
                  border: "1px solid #CFCFCF",
                }}
              >
                <FirstFormField
                  formData={saleDetail}
                  setFormData={setSaleDetail}
                  setIsChanged={setIsChanged}
                  onBlurAction={onBlurAction}
                  error={error}
                />
                <LiabilityTypes
                  formData={saleDetail}
                  setFormData={setSaleDetail}
                  setIsChanged={setIsChanged}
                />
                <LeadTypes
                  formData={saleDetail}
                  setFormData={setSaleDetail}
                  setIsChanged={setIsChanged}
                />
                <PropertyType
                  formData={saleDetail}
                  setFormData={setSaleDetail}
                  setIsChanged={setIsChanged}
                />
              </Grid>
            </>
          </DialogContentText>
        </DialogContent>
      </Popup>
      {alerModeShow && (
        <ResetFormAlert
          open={alerModeShow}
          title=""
          alertModalShow={alerModeShow}
          setAlertModelShow={setAlertModelShow}
          setIsClickReset={setIsClickReset}
        />
      )}
    </>
  );
};

export default ManageSale;
